import {
	createActionsHook,
	createContainer,
	createHook,
	createStateHook,
	createStore,
	defaults,
} from 'react-sweet-state';

import { type Product, type RemoteAction, type RemoteActionsMetas } from '../../common/types';

import { actions, type RemoteActionsActions } from './actions';

// jira freezes the global defaults object
if (!Object.isFrozen(defaults)) {
	defaults.devtools = process.env.NODE_ENV === 'development' && !process.env.CI;
}

export type RemoteActionsStoreState = {
	isLoaded: boolean;
	lastUpdatedAt: number;
	meta: RemoteActionsMetas;
	product: Product | undefined;
	remoteActions: { [id: string]: RemoteAction };
};

const Store = createStore<RemoteActionsStoreState, RemoteActionsActions>({
	initialState: {
		meta: {},
		remoteActions: {},
		lastUpdatedAt: 0,
		isLoaded: false,
		product: undefined,
	},
	actions,
	name: 'remoteActionsStore',
});

export const RemoteActionsContainer = createContainer<
	RemoteActionsStoreState,
	RemoteActionsActions,
	{ product: Product }
>(Store, {
	onInit:
		() =>
		({ dispatch }) => {
			dispatch(actions.initStore());
		},
});

export const useRemoteActions = <T = RemoteActionsStoreState>(
	selector?: (state: RemoteActionsStoreState) => T,
) =>
	createHook<RemoteActionsStoreState, RemoteActionsActions, T>(Store, {
		selector,
	})();

export const useRemoteActionsData = createStateHook(Store, {
	selector: (state) => state.remoteActions,
});

export const useMeta = createStateHook(Store, {
	selector: (state) => state.meta,
});

export const useRemoteActionLastUpdatedAt = createStateHook(Store, {
	selector: (state) => state.lastUpdatedAt,
});

export const useRemoteActionsStoreActions = createActionsHook<
	RemoteActionsStoreState,
	RemoteActionsActions
>(Store);
